import { render, staticRenderFns } from "./SelectLink.vue?vue&type=template&id=2fde7605&scoped=true"
import script from "./SelectLink.vue?vue&type=script&lang=js"
export * from "./SelectLink.vue?vue&type=script&lang=js"
import style0 from "./SelectLink.vue?vue&type=style&index=0&id=2fde7605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde7605",
  null
  
)

export default component.exports